/**
 * Spec validation at the point of order — docs/04-catalog-spec.md
 *
 * Catches the two failures that produce a remake or, worse, a citation:
 *
 *   1. Text too long for the selected size. A 24" panel at the letter height
 *      needed for 50-foot legibility fits roughly 18 characters per line. Past
 *      that, something has to shrink, and what shrinks is the letter height —
 *      the one dimension that must not.
 *
 *   2. A malformed USDOT number. Five to eight digits, no letters, no "USDOT"
 *      prefix typed into the field.
 *
 * This warns; it does not block. A carrier with an unusual legal name knows
 * more about their name than we do. Blocking would cost a real order to prevent
 * a hypothetical one.
 */
(function () {
  "use strict";

  var container = document.querySelector(".mmf-line-items");
  if (!container) return;

  // Characters per line at a given panel width, cutting at 2" letter height.
  // Derived from the size table in data/catalog/products.json. [ESTIMATE] —
  // confirm against real cut files before this drives anything but a warning.
  var CHARS_PER_LINE = { 12: 9, 24: 18 };

  function panelWidthInches() {
    // Dawn renders the selected variant title as e.g. '24" x 3.5" / Black / Pair'.
    var selected = document.querySelector('[name="id"] option:checked, [name="id"]');
    var title = (selected && (selected.textContent || selected.value)) || "";
    var match = title.match(/(\d+)"\s*x/);
    return match ? parseInt(match[1], 10) : null;
  }

  function warn(input, message) {
    var id = input.id + "-warn";
    var existing = document.getElementById(id);
    if (!message) {
      if (existing) existing.remove();
      return;
    }
    var el = existing || document.createElement("p");
    el.id = id;
    el.className = "mmf-line-items__warn";
    el.setAttribute("role", "status");
    el.textContent = message;
    if (!existing) input.insertAdjacentElement("afterend", el);
  }

  container.addEventListener("input", function (e) {
    var input = e.target;
    if (input.tagName !== "INPUT") return;

    var name = (input.name.match(/properties\[(.+)\]/) || [])[1] || "";
    var value = input.value.trim();

    if (/usdot|dot number/i.test(name)) {
      if (value && !/^\d{5,8}$/.test(value)) {
        warn(input, "A USDOT number is 5 to 8 digits. Leave off the letters 'USDOT' — we add those.");
      } else {
        warn(input, "");
      }
      return;
    }

    if (/name|line/i.test(name)) {
      var width = panelWidthInches();
      var limit = width && CHARS_PER_LINE[width];
      if (limit && value.length > limit) {
        warn(
          input,
          value.length + " characters will not fit " + width + '" at 2" letters. ' +
            "We will cut it, but the lettering gets smaller — which is the one thing " +
            "the 50-foot standard cares about. Consider a wider panel or a second line."
        );
      } else {
        warn(input, "");
      }
    }
  });
})();
